import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import "./admin.css";

import axios from "axios";
import PopUpModal from "../../components/PopUpModal";
import { useDispatch } from "react-redux";
import { showModal } from "../../Redux/actions/modalActions";

function CreateProduct() {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [details, setDetails] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState();

  const dispatch = useDispatch();

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
    }
  };
  const resetState = () => {
    setName("");
    setPrice("");
    setDetails("");
    setCategory("");
    setImage("");
  };

  const removeSelectedImage = () => {
    setImage();
  };

  const handleCreateProduct = () => {
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_HOST_API}/product`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: {
        name,
        price,
        details,
        category,
        image,
      },
    })
      .then((result) => {
        dispatch(showModal());
        console.log(result)
        resetState();
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    document.title = "Create Product";
  }, []);

  return (
    <>
      <Navbar />
      <div className="container create-p-container">
        <header className="p-details-header">
          <Link to="/products">Product</Link>
          <Link to="/createProduct"> / Create Product</Link>
        </header>
        <section className="create-p-left-section d-flex">
          <div className="create-product-image">
            <div className="details-product-image">
              {image ? (
                <img
                  src={URL.createObjectURL(image)}
                  //   style={styles.image}
                  alt="Thumb"
                />
              ) : (
                <div className="empty-img" />
              )}
            </div>{" "}
            <br />
            <div>
              <button className="upload-button take-a-picture">
                take a picture
              </button>{" "}
              <br />
              <input
                className="d-none"
                type="file"
                id="upload-button"
                accept="image/*"
                onChange={imageChange}
              />
              <label className="upload-button " htmlFor="upload-button">
                Choose photo
              </label>
              {image && (
                <button className="remove-pict" onClick={removeSelectedImage}>
                  Remove This Image
                </button>
              )}
            </div>
          </div>
          <form className="form-create-p">
            <label htmlFor="name" className="label-create-p">
              Name:
            </label>{" "}
            <br />
            <input
              type="text"
              id="name"
              name="name"
              defaultValue={name}
              placeholder="Type the product name"
              onChange={(e) => setName(e.target.value)}
            />{" "}
            <br />
            <label htmlFor="price" className="label-create-p">
              Price:
            </label>{" "}
            <br />
            <input
              type="text"
              id="price"
              name="price"
              defaultValue={price}
              placeholder="Type the price ex: 25000"
              onChange={(e) => setPrice(e.target.value)}
            />{" "}
            <br />
            <label htmlFor="details" className="label-create-p">
              Description:
            </label>{" "}
            <br />
            <input
              type="text"
              id="details"
              name="details"
              placeholder="Describe your product"
              onChange={(e) => setDetails(e.target.value)}
            />
          </form>
        </section>
        <section className="create-p-right-section d-flex">
          <div className="create-category-wrapper">
            <label htmlFor="category" className="label-create-p">
              Input Product Category:
            </label>{" "}
            <br />
            <div
              className="delivery-category d-flex"
              style={{ justifyContent: "space-evenly" }}
            >
              <input
                className="radio_input d-none"
                type="radio"
                name="category"
                id="Coffee"
                value="07e88ba9-1a54-46ab-bf2c-3dc8831090a4"
                onClick={(e) => {
                  setCategory(e.target.value);
                }}
              />
              <label htmlFor="Coffee" className="radio_label dine-in-btn">
                Coffee
              </label>
              <input
                className="radio_input d-none"
                type="radio"
                name="category"
                id="NonCoffee"
                value="30b95dde-a820-41dd-b474-902026e3e755"
                onClick={(e) => {
                  setCategory(e.target.value);
                }}
              />
              <label htmlFor="NonCoffee" className="radio_label dine-in-btn">
                Non Coffee
              </label>
              <input
                className="radio_input d-none"
                type="radio"
                name="category"
                id="Foods"
                value="ea71bfcd-f1f1-4976-ae1e-9ff0f2c70d0e"
                onClick={(e) => {
                  setCategory(e.target.value);
                }}
              />
              <label htmlFor="Foods" className="radio_label dine-in-btn">
                Foods
              </label>
            </div>
          </div>
          <div className="create-btn-wrapper d-flex">
            <button
              className="save-prdct-btn"
              style={{ background: "#6A4029", color: "#fff" }}
              onClick={handleCreateProduct}
            >
              Save product
            </button>
            <button className="cancel-btn">Cancel</button>
          </div>
        </section>
      </div>
      <PopUpModal body={"Product Successfully Added!"} closeBtnOnly={true} />
      <Footer />
    </>
  );
}

export default CreateProduct;
